export default "__VITE_ASSET__h5y8p3Im__"